import { InputWrapper, MtFormContainer, StepLine } from '@presentation/components';
import type { FC } from 'react';
import { useEffect } from 'react';
import { useRouter } from '@application/utils';
import { TbArrowNarrowRight } from 'react-icons/tb';
import { BREAKPOINTS } from '@presentation/styles';
import { BREEDER_ONBOARDING_MAX_STEP } from '@application/constants';
import * as Styled from './styled';
import { IMAGES } from './assets';
import type { MtBreederOnboardingPageProps } from './types';

export * from './types';
export * from './components';

export const MtBreederOnboardingPage: FC<MtBreederOnboardingPageProps> = (props) => {
  const {
    steps,
    stepLineProps,
    currentStep,
    onBackClick,
    onNextClick,
    loading = false,
    onCloseClick,
    onFinishOnboardingClick,
  } = props;

  const { translate } = useRouter();

  useEffect(() => {
    const element = document.getElementById('target-element');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }, [currentStep]);

  return (
    <>
      {currentStep > 0 && currentStep <= BREEDER_ONBOARDING_MAX_STEP ? (
        <Styled.OnboardingIconsContainer id="target-element" currentStep={currentStep}>
          {currentStep >= 1 && currentStep < BREEDER_ONBOARDING_MAX_STEP ? (
            <Styled.OnboardingPrev
              src={IMAGES.onboardingPrev}
              currentStep={currentStep}
              onClick={onBackClick}
            />
          ) : null}
          {currentStep > 0 && currentStep < BREEDER_ONBOARDING_MAX_STEP ? (
            <Styled.TopWrapper marginTop={40} marginBottom={30}>
              {currentStep >= 0 && currentStep < BREEDER_ONBOARDING_MAX_STEP ? (
                <Styled.OnboardingDog src={IMAGES.onboardingDog} />
              ) : null}
              <Styled.StepLineWrapper>
                <StepLine
                  currentStep={stepLineProps.currentStep}
                  steps={stepLineProps.steps}
                  color="dark"
                  verticalBreakpoint={BREAKPOINTS.tablet}
                />
              </Styled.StepLineWrapper>
            </Styled.TopWrapper>
          ) : null}
          {currentStep > 0 && currentStep <= BREEDER_ONBOARDING_MAX_STEP ? (
            <Styled.OnboardingPrev
              src={IMAGES.onboardingClose}
              currentStep={currentStep}
              onClick={onCloseClick}
            />
          ) : null}
        </Styled.OnboardingIconsContainer>
      ) : null}
      <MtFormContainer>
        {steps[currentStep].component}

        <InputWrapper>
          {currentStep === BREEDER_ONBOARDING_MAX_STEP ? (
            <Styled.ButtonContainer>
              <Styled.OnboardingButton
                color="blue"
                onClick={onFinishOnboardingClick}
                isFull
                loading={loading}
              >
                {translate('common.inputs.steps.createBreedButton')}
              </Styled.OnboardingButton>
            </Styled.ButtonContainer>
          ) : null}
          {currentStep > 0 && currentStep < BREEDER_ONBOARDING_MAX_STEP ? (
            <Styled.ButtonContainer>
              <Styled.OnboardingButton
                color="blue"
                onClick={onNextClick}
                iconRight={<TbArrowNarrowRight />}
                loading={loading}
              >
                {translate('common.buttons.continue')}
              </Styled.OnboardingButton>
            </Styled.ButtonContainer>
          ) : null}
        </InputWrapper>
      </MtFormContainer>
    </>
  );
};
